import { CSS } from "../styles";

export default function LoadingScreen() {
  return (
    <div style={{ background: "#0F0E0C", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <style>{CSS}</style>
      <div style={{ width: 36, height: 36, background: "#C9A96E", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>⬡</div>
      <div className="spinner" />
    </div>
  );
}
